import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
// import logo from "../../assets/images/clients/3.png";
// import img1 from "../../assets/logo/icons8-united-kingdom-48.png";
// import img2 from "../../assets/logo/icons8-egypt-48.png";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../store/language/lanSlicer";
import { baseUrl } from "../../utils/APi";
import { getSocialMedia } from "../../store/contact/contactAction";
// const languages = [
//   {
//     code: "en",
//     name: "English",
//     dir: "ltr",
//     image: img2,
//   },
//   {
//     code: "ar",
//     name: "العربية",
//     dir: "rtl",
//     image: img1,
//   },
// ];

const SideNav = ({ navWidth, closeNav }) => {
  const sideRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (index) => {
    setOpenDropdown((prevIndex) => (prevIndex === index ? null : index));
  };

  // const dispatch = useDispatch();
  // const { t, i18n } = useTranslation();
  // const currentLanguageCode = Cookies.get("i18next") || "en";
  // const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  // const changeLanguage = (languageCode) => {
  //   i18n.changeLanguage(languageCode);
  //   Cookies.set("i18next", languageCode);
  // };
  // const [show, setShow] = useState(false);
  // const toggleLanguage = () => {
  //   const newLanguageCode = currentLanguage.code === "en" ? "ar" : "en";
  //   document.body.dir = newLanguageCode === "ar" ? "rtl" : "ltr";
  //   changeLanguage(newLanguageCode);
  //   dispatch(setLanguage(newLanguageCode));
  // };
  // const { SocialMedia } = useSelector((state) => state.contactSlice);

  // useEffect(() => {
  //     dispatch(getSocialMedia());
  // }, [dispatch]);

  //   useEffect(() => {
  //     function handleClickOutside(event) {
  //       if (sideRef.current && !sideRef.current.contains(event.target)) {
  //         Close();
  //       }
  //     }
  //     window.addEventListener("click", handleClickOutside);
  //     return () => {
  //       window.removeEventListener("click", handleClickOutside);
  //     };
  //   }, [Close]);

  return (
    <div className={`${navWidth ? "active" : " "} side-menu__block`}>
      <div className="side-menu__block-overlay custom-cursor__overlay">
        <div className="cursor"></div>
        <div className="cursor-follower"></div>
      </div>
      <div className="side-menu__block-inner ">
        <div className="side-menu__top justify-content-end">
          <a
            href="#"
            className="side-menu__toggler side-menu__close-btn"
            onClick={() => closeNav()}
          >
            <img src="assets/images/shapes/close-1-1.png" alt="" />
          </a>
        </div>

        <nav className="mobile-nav__container">
          <ul className="main-nav__navigation-box">
            <li className="dropdown current">
              <a href="index.html">Home</a>
              <ul>
                <li>
                  <a href="index.html">Home 01</a>
                </li>
                <li>
                  <a href="index2.html">Home 02</a>
                </li>
                <li>
                  <a href="index3.html">Home 03</a>
                </li>
                <li>
                  <a href="index4.html">Home 04</a>
                </li>
                <li>
                  <a href="index5.html">Home 05</a>
                </li>
                <li className="dropdown">
                  <a href="#">Header Versions</a>
                  <ul>
                    <li>
                      <a href="index.html">Header 01</a>
                    </li>
                    <li>
                      <a href="index2.html">Header 02</a>
                    </li>
                    <li>
                      <a href="index3.html">Header 03</a>
                    </li>
                    <li>
                      <a href="index4.html">Header 04</a>
                    </li>
                    <li>
                      <a href="index5.html">Header 05</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="service.html">Services</a>
              <ul>
                <li>
                  <a href="service.html">Services</a>
                </li>
                <li>
                  <a href="service-detail.html">Services Detail</a>
                </li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="projects.html">Our Projects</a>
              <ul>
                <li>
                  <a href="projects.html">Projects</a>
                </li>
                <li>
                  <a href="projects_detail.html">Projects Detail</a>
                </li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="#">Shop</a>
              <ul>
                <li>
                  <a href="product.html">Products</a>
                </li>
                <li>
                  <a href="product-detail.html">Product Detail</a>
                </li>
                <li>
                  <a href="cart.html">Cart</a>
                </li>
                <li>
                  <a href="checkout.html">Checkout</a>
                </li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="#">Pages</a>
              <ul>
                <li>
                  <a href="about.html">About</a>
                </li>
                <li>
                  <a href="why_choose_us.html">Why Choose Us</a>
                </li>
                <li>
                  <a href="farmers.html">Farmers</a>
                </li>
                <li>
                  <a href="gallery.html">Gallery</a>
                </li>
              </ul>
            </li>
            <li className="dropdown">
              <a href="#">News</a>
              <ul>
                <li>
                  <a href="news.html">News</a>
                </li>
                <li>
                  <a href="news_detail.html">News Details</a>
                </li>
              </ul>
            </li>
            <li>
              <a href="contact.html">Contact</a>
            </li>
          </ul>
        </nav>

        <div className="side-menu__sep"></div>

        <div className="side-menu__content">
          <p>
            <a href="mailto:needhelp@tripo.com">needhelp@agricol.com</a> <br />{" "}
            <a href="tel:888-999-0000">888 999 0000</a>
          </p>
          <div className="side-menu__social">
            <a href="#">
              <i className="fab fa-facebook-square"></i>
            </a>
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#">
              <i className="fab fa-pinterest-p"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
